import React from 'react';
import { IconInfoRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

interface CouponBannerProps {
  noticeText?: string | null;
}

export const CouponBanner: React.FC<React.PropsWithChildren<CouponBannerProps>> = ({ noticeText }) => {
  const isHide = !noticeText;

  return (
    <Container isHide={isHide}>
      {!isHide && (
        <>
          <IconInfoRegular width={20} height={20} v3Color='gray500' />
          <NoticeContent className={Typography.BODY_14_MEDIUM}>{noticeText}</NoticeContent>
        </>
      )}
    </Container>
  );
};

const Container = styled.div<{ isHide: boolean }>`
  ${({ isHide }) =>
    isHide ? 'padding: 8px 0 0 0' : `padding: 16px 16px 24px; border-top: 1px solid ${vars.v3Color.gray30};`};
  display: flex;
  align-content: center;

  > svg {
    margin: -2px 2px 0 0;
  }
`;

const NoticeContent = styled.span`
  color: ${vars.v3Color.gray500};
`;
